import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-caption" }
const _hoisted_2 = { class: "text-caption" }
const _hoisted_3 = { class: "text-caption" }
const _hoisted_4 = { class: "text-caption" }
const _hoisted_5 = { class: "text-caption" }


import StateOfAccountDialogViewModel from "@/viewmodels/dialogs/StateOfAccountDialogViewModel";
import { Saving } from "@/models/Saving";
import { Movimiento } from "@/models/Movimiento";


export default /*@__PURE__*/_defineComponent({
  __name: 'StateOfAccountDialog',
  setup(__props, { expose: __expose }) {

const viewModel = new StateOfAccountDialogViewModel();

// Exponemos directamente los métodos sin usar `bind`
__expose({
  openDialog: (saving: Saving, movements: Movimiento[]) =>
    viewModel.openDialog(saving, movements),
  closeDialog: () => viewModel.closeDialog(),
});

return (_ctx: any,_cache: any) => {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: _unref(viewModel).dialog.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(viewModel).dialog.value) = $event)),
    persistent: "",
    "max-width": "1200px"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "d-flex justify-between align-center" }, {
            default: _withCtx(() => [
              _cache[3] || (_cache[3] = _createElementVNode("span", { class: "text-subtitle-1 font-weight-bold" }, " Estado de Cuenta ", -1)),
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                disabled: _unref(viewModel).loadingPdf.value,
                variant: "flat",
                icon: "",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(viewModel).closeDialog()))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => _cache[2] || (_cache[2] = [
                      _createTextVNode("mdi-close")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_divider),
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_container, {
                fluid: "",
                class: "pa-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, { dense: "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { cols: "12" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card, { flat: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_row, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, { cols: "12" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_table, {
                                        density: "compact",
                                        height: "400px",
                                        "fixed-header": "",
                                        style: {"border-left":"7px solid rgb(var(--v-theme-primary), 0.4)"}
                                      }, {
                                        default: _withCtx(() => [
                                          _cache[4] || (_cache[4] = _createElementVNode("thead", null, [
                                            _createElementVNode("tr", null, [
                                              _createElementVNode("th", { class: "text-left" }, "Concepto"),
                                              _createElementVNode("th", { class: "text-left" }, "Fecha"),
                                              _createElementVNode("th", { class: "text-left" }, "Hora"),
                                              _createElementVNode("th", {
                                                class: "text-left",
                                                style: {"min-width":"100px"}
                                              }, " Total "),
                                              _createElementVNode("th", {
                                                class: "text-left",
                                                style: {"min-width":"100px"}
                                              }, " Saldo ")
                                            ])
                                          ], -1)),
                                          _createElementVNode("tbody", null, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(viewModel).accountStatement
                            .value, (item, idx) => {
                                              return (_openBlock(), _createElementBlock("tr", {
                                                key: `estado-${idx}`
                                              }, [
                                                _createElementVNode("td", _hoisted_1, _toDisplayString(item.concepto), 1),
                                                _createElementVNode("td", _hoisted_2, _toDisplayString(_unref(viewModel).formatDate(item.fecha)), 1),
                                                _createElementVNode("td", _hoisted_3, _toDisplayString(item.hora), 1),
                                                _createElementVNode("td", _hoisted_4, _toDisplayString(_unref(viewModel).coin.value) + " " + _toDisplayString(_unref(viewModel).getFloat(item.total)), 1),
                                                _createElementVNode("td", _hoisted_5, _toDisplayString(_unref(viewModel).coin.value) + " " + _toDisplayString(_unref(viewModel).getFloat(item.saldo)), 1)
                                              ]))
                                            }), 128))
                                          ])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, { class: "text-end" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_btn, {
                                        flat: "",
                                        color: "primary",
                                        class: "text-none",
                                        loading: _unref(viewModel).loadingPdf.value,
                                        onClick: _withModifiers(_unref(viewModel).downloadAccountStatement, ["prevent"])
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_icon, { class: "mr-2" }, {
                                            default: _withCtx(() => _cache[5] || (_cache[5] = [
                                              _createTextVNode("mdi-download")
                                            ])),
                                            _: 1
                                          }),
                                          _cache[6] || (_cache[6] = _createTextVNode(" Descargar Estado de Cuenta "))
                                        ]),
                                        _: 1
                                      }, 8, ["loading", "onClick"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})